import React from "react";
import { Box } from "../../components/Box";
import { Flex } from "../../components/Flex";
import { CardLine, Heading } from ".";
import { sourceOfFundsDetail } from "../../types/Individual";
import { Image } from "../../components/Image";
import {
  RiskLevelColors,
  RiskLevelEnum,
} from "../../context/MandateStatusContext";
import { capitalise } from "../../utils/string";
import sourceOfFunds from "../../assets/source_of_funds.svg";
import document from "../../assets/document.svg";
import { Paragraph } from "../../components/Paragraph";

// Top-level Employment Card
const SourceOfFundsCard: React.FC<{
  sourceOfFundsDetails: sourceOfFundsDetail[];
}> = ({ sourceOfFundsDetails }) => {
  return (
    <>
      {sourceOfFundsDetails?.length > 0 && (
        <>
          <Flex justifyContent={"space-between"} alignItems={"center"}>
            <Heading>Source of Funds</Heading>
            <FundsDetails sourceOfFund={sourceOfFundsDetails} />
          </Flex>
          <hr></hr>
          <SourceOfFundsDetails sourceOfFund={sourceOfFundsDetails} />
        </>
      )}
    </>
  );
};

// Income Details Component
const FundsDetails: React.FC<{ sourceOfFund: sourceOfFundsDetail[] }> = ({
  sourceOfFund,
}) => {
  const sum = sourceOfFund
    .map((item) => item.amount)
    .reduce((prev, curr) => prev + curr, 0);

  const currencySymbol = sourceOfFund?.[0]?.currency?.symbol || "£";

  return (
    <Box>
      <CardLine>
        Source of Funds Total &nbsp; &nbsp;
        <span
          style={{
            fontSize: 16,
            color: "black",
          }}
        >
          {" "}
          {currencySymbol} {sum.toLocaleString()}
        </span>
      </CardLine>
    </Box>
  );
};

// Employment Details Section
const SourceOfFundsDetails: React.FC<{
  sourceOfFund: sourceOfFundsDetail[];
  title?: string;
}> = ({ sourceOfFund }) => (
  <Box mb={3}>
    {sourceOfFund.map((sourceOfFund, index) => (
      <Flex gap="12" key={index}>
        <Box flex={1}>
          <Heading></Heading>
          <Flex alignItems={"center"} my={4}>
            <Image
              src={sourceOfFunds}
              alt="indicator icon"
              height="20px"
              width="24px"
            />
            <CardLine>{sourceOfFund?.source_name}</CardLine>
          </Flex>
        </Box>
        <Box flex={1}>
          <Heading>Description</Heading>
          <CardLine>
            {sourceOfFund?.description ? sourceOfFund?.description : "-"}
          </CardLine>
        </Box>
        <Box flex={1}>
          <Heading>Document</Heading>
          <Flex alignItems={"center"}>
            {sourceOfFund?.document ? (
              <>
                <Image
                  src={document}
                  alt="document icon"
                  height="20px"
                  width="24px"
                />
                <CardLine>{sourceOfFund?.document_name}</CardLine>
              </>
            ) : (
              "-"
            )}
          </Flex>
        </Box>
        <Box flex={1}>
          <Heading>Amount</Heading>
          <CardLine>
            <CardLine>
              {sourceOfFund?.amount
                ? `${
                    sourceOfFund?.currency?.symbol || "£"
                  } ${sourceOfFund?.amount.toLocaleString()}`
                : "-"}
            </CardLine>
          </CardLine>
          <Heading style={{ marginTop: "4%" }}>Risk Level</Heading>
          <Paragraph my="0" width="70px" color={RiskLevelColors[sourceOfFund?.risk_level]}>
              {" "}
              {capitalise(RiskLevelEnum[sourceOfFund?.risk_level])}
          </Paragraph>
        </Box>
      </Flex>
    ))}
  </Box>
);

export default SourceOfFundsCard;
